import './css/app.css'
import Header from './components/Header';
import Footer from "./components/Footer";
import Home from "./pages/home";
import Addresses from "./pages/addresses";
import Location from "./pages/location";
import Lodging from "./pages/lodging";
import Committees from "./pages/committees";
import Schedule from "./pages/schedule";
import Photos from "./pages/photos";
import { Route, Routes, useLocation } from "react-router-dom";
import ContactUs from './pages/contactus';
import JoinUs from './pages/joinus';


function App() {
  const location = useLocation();
  const locationClassName = (location.pathname === '/') ? "home" : location.pathname.slice(1);
  //console.log(location.pathname);

  return (
    <>
      <Header />
      <div className={ "container " +  locationClassName }>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/addresses" element={<Addresses />} />
          <Route path="/location" element={<Location />} />
          <Route path="/lodging" element={<Lodging />} />
          <Route path="/committees" element={<Committees />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/photos" element={<Photos />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/joinus" element={<JoinUs />} />
        </Routes>
      </div>
      <Footer />
    </>
  );

}

export default App;
